import Vue from 'vue'
import Avatar from './Avatar.vue'

const components = { Avatar }

Object.keys(components).forEach(name => {
  Vue.component(name, components[name])
})